<!--<p>Seleccione un Código de Viaje</p> -->
<div style="width: 100%;height: 500px;"> <!--class="a-example-full-width-alterno-content-2" -->
    <app-datatable [dataTable]="serviciosytarifas_NaveViajePorPuerto" [metadataTable]="metadatableNaveViajePorPuerto"
        [style]="estilos" [key]="'codigoviaje'" [filterGlobal]="true" (selectedRowData)="row = $event"
        [resaltarCabecera]="true" [ajustarTitulos]="true" [lineasTabla]="true" [rows]="[500]">
    </app-datatable>
</div>